import type { SxProps, Theme } from "@mui/material/styles";
import { colors } from "../../../../../utils/colors";

export const multiDimensionBarChartConfig = {
  height: 400,
  minHeight: 400,
  legendTop: 8,
  legendRight: 50,
  xAxisRotateThreshold: 8,
  xAxisRotateDegrees: 35,
  xAxisLabelColor: colors.black,
  xAxisLabelFontSize: "0.625rem",
  xAxisLabelFontWeight: 500,
  yAxisLabelColor: colors.chart_gray,
  yAxisLabelFontSize: "0.6875rem",
  barMaxWidth: 30,
  emptyStateMinHeight: 280,
  resizeDelayMs: 350,
  splitLineOpacity: 0.2,
  tooltipZIndex: "z-index: 10000;",
};

export const multiDimensionBarLegendDefaults = {
  orient: "horizontal" as const,
  icon: "roundRect" as const,
  itemWidth: 14,
  itemHeight: 14,
  itemGap: 16,
};

export const multiDimensionBarGridDefaults = {
  left: "5%",
  right: "5%",
  top: "14%",
  bottom: "18%",
  containLabel: true,
};

export const multiDimensionBarAxisLineStyle = { show: false };

export const multiDimensionBarAxisTickStyle = { show: false };

export const multiDimensionBarTooltipTextStyle = {
  color: colors.chart_text,
};

export const getMultiDimensionBarTitleSx = (
  titleAlign: "left" | "center" | "right",
): SxProps<Theme> => ({
  px: 2,
  mb: "0.25rem",
  fontWeight: 500,
  fontSize: "16px",
  color: colors.light_black,
  textAlign: titleAlign,
});

export const multiDimensionBarChartStyles = {
  root: {
    minWidth: 0,
  } satisfies SxProps<Theme>,
  emptyStateContainer: {
    minWidth: 0,
    px: 2,
    py: 6,
    minHeight: multiDimensionBarChartConfig.emptyStateMinHeight,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  } satisfies SxProps<Theme>,
  chartWrapper: (
    minHeight: number,
    loading: boolean,
    hasData: boolean,
  ): SxProps<Theme> => ({
    minHeight,
    px: 2,
    minWidth: 0,
    opacity: loading && !hasData ? 0.5 : 1,
  }),
  chartCanvas: (height: number): SxProps<Theme> => ({
    width: "100%",
    minWidth: 0,
    height,
  }),
  chartPlaceholder: (minHeight: number): SxProps<Theme> => ({
    width: "100%",
    minHeight,
    minWidth: 0,
  }),
};
